import { Form, Icon, Select, Tag, Tooltip } from "antd";
import React, { useContext } from "react";
import AlertAllowedApps from "./AlertAllowedApps";
import { FreireContext } from "../../utils/freireContext";
import * as texts from "./locales";
import WhiteLabelAvatar from "../../components/WhiteLabelAvatar";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { ICompany } from "../../interfaces/company";
import { BRAND_WHITELABEL_ALIAS, useWhitelabels } from "../../components/WhitelabelThemesProvider";

const RequiredTupiApp = () => {
  const { freire } = useContext(FreireContext);
  const { getWhitelabelByAlias } = useWhitelabels();
  const whitelabel = getWhitelabelByAlias(BRAND_WHITELABEL_ALIAS);
  if (!whitelabel) return null;
  return (
    <span style={{ display: "flex", marginTop: 4 }}>
      {freire(texts.THE_APP_LABEL)}
      <Tag style={{ margin: "0px 5px" }}>
        <WhiteLabelAvatar whitelabel={whitelabel} />
      </Tag>
      {freire(texts.IS_REQUIRED_LABEL)}
    </span>
  );
};

type Props = {
  form: WrappedFormUtils<any>;
  initialValue?: string[];
  loading: boolean;
  isHolding: boolean;
  parentCompany: ICompany;
};

const AllowedAppsForm = ({
  form,
  initialValue,
  loading,
  isHolding,
  parentCompany,
}: Props) => {
  const { freire } = useContext(FreireContext);
  const { allWhitelabels } = useWhitelabels();
  const { getFieldDecorator } = form;

  const allowed_apps =
    form.getFieldValue("allowed_apps") || (initialValue ?? []);

  const inputValidator = async (
    _: any,
    allowed_apps: string[],
    callback: any
  ) => {
    const requiredTupiApp =
      allowed_apps?.length >= 1 &&
      !allowed_apps?.some((app: string) => app === BRAND_WHITELABEL_ALIAS);

    if (requiredTupiApp) {
      callback(<RequiredTupiApp />);
    }

    callback();
  };

  return (
    <Form.Item
      label={
        <span>
          <span>{freire(texts.ALLOWED_APPS_LABEL)}</span>{" "}
          <Tooltip title={freire(texts.ALLOWED_APPS_DESCRIPTION)}>
            <Icon type="question-circle-o" />
          </Tooltip>
        </span>
      }
    >
      {!isHolding && (
        <AlertAllowedApps
          allowedApps={allowed_apps}
          parentCompany={parentCompany}
        />
      )}
      {getFieldDecorator("allowed_apps", {
        ...(initialValue && { initialValue }),
        rules: [
          {
            required: isHolding,
            message: freire(texts.REQUIRED),
          },
          {
            validator: inputValidator,
          },
        ],
      })(
        <Select
          allowClear
          showSearch
          optionFilterProp="children"
          mode="multiple"
          loading={loading}
          disabled={loading || Object.values(allWhitelabels).length === 0}
          placeholder={freire(texts.SELECT_APPS_TITLE)}
        >
          {Object.values(allWhitelabels).map((whiteLabel) => (
            <Select.Option key={whiteLabel.alias} value={whiteLabel.alias}>
              <WhiteLabelAvatar whitelabel={whiteLabel} />
            </Select.Option>
          ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default AllowedAppsForm;
